import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import styled from "styled-components";
import UnstyledButton from "../UnstyledButton";
import useDrawerContext from "./useDrawerContext";

const DrawerClose = () => {
  const { onClose } = useDrawerContext();

  return (
    <CloseButton aria-label="Close" onClick={onClose}>
      <CloseIcon icon={faTimes} />
    </CloseButton>
  );
};

const CloseIcon = styled(FontAwesomeIcon)`
  display: block;
  font-size: 18px;
`;

const CloseButton = styled(UnstyledButton)`
  position: absolute;
  top: 1rem;
  right: 1rem;
  padding: 1rem;
`;

export default DrawerClose;
